import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import Header from './Header';
import ScrollTopButton from 'components/ScrollTopButton';

export default function UnifiedLayout({
  children,
  $withSidebar = false,
  enableScrollTopButton = false
}: {
  children?: React.ReactNode;
  $withSidebar?: boolean;
  enableScrollTopButton?: boolean;
}) {
  const [showArrow, setShowArrow] = useState(false);

  const contentRef = React.useRef<HTMLDivElement>(null);
  const handleScrollTop = () => {
    contentRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    if (!enableScrollTopButton) return;
    const el = contentRef.current;
    if (!el) return;

    const onScroll = () => setShowArrow(el.scrollTop > 200);
    el.addEventListener('scroll', onScroll);
    return () => el.removeEventListener('scroll', onScroll);
  }, [enableScrollTopButton]);

  return (
    <LayoutBase>
      <Header />
      {$withSidebar ? (
        <div className="wrapper">
          <Sidebar />
          <PageContent $withSidebar={$withSidebar}>{children}</PageContent>
        </div>
      ) : (
        <PageContent ref={contentRef} $withSidebar={$withSidebar}>
          {children}
        </PageContent>
      )}
      {enableScrollTopButton && <ScrollTopButton show={showArrow} onClick={handleScrollTop} />}
    </LayoutBase>
  );
}

const LayoutBase = styled.div<{ $withSidebar?: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  ${({ $withSidebar }) => !$withSidebar && 'position: relative;'}

  .wrapper {
    display: flex;
    width: 100%;
    margin-top: 56px;
  }
`;

const PageContent = styled.div<{ $withSidebar?: boolean }>`
  flex: 1;
  padding: ${({ $withSidebar }) => ($withSidebar ? '44px 49px 36px 45px' : '42px 20px 70px 20px')};
  box-sizing: border-box;
  overflow-y: auto;
  ${({ $withSidebar }) => !$withSidebar && 'margin-top: 56px;'}
`;
